import { BiblesMutationTypes } from './mutation_types'
import { BibleState } from './state'

export const mutations: StoreMutations<BiblesMutationTypes, BibleState> = {
  [BiblesMutationTypes.ADD_BIBLE] (state, value) {
    state.bibles.push(value)
  },
  [BiblesMutationTypes.REMOVE_BIBLE_PENDING] (state, index) {
    state.biblePendingIds.splice(index, 1)
  },
  [BiblesMutationTypes.SET_BIBLE_PROGRESS] (state, data) {
    const bibleIndex = state.bibles.findIndex(item => item.id === data.bible)

    if (bibleIndex !== -1) {
      state.bibles[bibleIndex] = {
        ...state.bibles[bibleIndex],
        renderProgress: data.progress,
      };
    }
  },
  [BiblesMutationTypes.SET_BIBLE_ERROR] (state, value) {
    state.bibleError = value
  },
  [BiblesMutationTypes.SET_BIBLE_PENDING] (state, id) {
    state.biblePendingIds.push(id)
  },
  [BiblesMutationTypes.SET_BIBLES] (state, value) {
    state.bibles = value
  },
  [BiblesMutationTypes.SET_BIBLES_ERROR] (state, value) {
    state.biblesError = value
  },
  [BiblesMutationTypes.SET_BIBLES_PENDING] (state, value) {
    state.biblesPending = value
  },
  [BiblesMutationTypes.SET_EXPORT_BIBLE_TO_IMANAGE_ERROR] (state, value) {
    state.exportBibleToImanageError = value
  },
  [BiblesMutationTypes.SET_EXPORT_BIBLE_TO_IMANAGE_PENDING] (state, value) {
    state.exportBibleToImanagePending = value
  },
  [BiblesMutationTypes.SET_POST_BIBLE_PENDING] (state, value) {
    state.postBiblePending = value
  },
}
